module.exports = __webpack_public_path__ + "img/hide-image.7d835d25.svg";